import { FunctionComponent, useEffect, useState } from 'react'
import { useT } from '@transifex/react'
import { reactular } from '@vendhq/reactular'
import {
  REACT_UTILITIES_TRANSIFEX_TAG,
  useTWithTag,
} from '@vend/react-utilities'
import { useWebRegisterManager } from '../../ng-compat/hooks'

/**
 * This is working around an issue where react components
 * are not updating translations on transifex load. Problem
 * is in the reactWrapper. Best fix for this is to complete
 * reactificiation but in the mean time need to work around it here.
 */

export const useTranslateTitle = () => {
  const webRegisterManager = useWebRegisterManager()

  const [translationsAvailable, setTranslationsAvailable] = useState<boolean>(
    webRegisterManager.getTranslationsAvailable()
  )
  const t = useT()
  const utilitiesT = useTWithTag(REACT_UTILITIES_TRANSIFEX_TAG)
  const title = t('Sell')

  useEffect(() => {
    const updateTranslationsAvailable = () => {
      setTranslationsAvailable(webRegisterManager.getTranslationsAvailable())
    }

    webRegisterManager.on('translationsAvailable', updateTranslationsAvailable)

    return () => {
      webRegisterManager.off(
        'translationsAvailable',
        updateTranslationsAvailable
      )
    }
  }, [webRegisterManager])

  useEffect(() => {
    if (!translationsAvailable) {
      return
    }
    document.title = `${title} | ${utilitiesT('Lightspeed Retail')}`
  }, [t, title, translationsAvailable, utilitiesT])
}

export const TranslateTitle: FunctionComponent = () => {
  useTranslateTitle()
  return null
}

export const ReactTranslateTitle = reactular(TranslateTitle, [], 'reactWrapper')
